import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { useDroppable } from '@dnd-kit/core'

// Each crumb above the folder you're in is a drop target, which is the only way to get an item or a
// subfolder back out of a deep branch without opening the level you want it in first.
const DroppableCrumb = ({ dropId, onClick, children }) => {
  const { isOver, setNodeRef } = useDroppable({ id: dropId })

  return (
    <Breadcrumb.Item
      ref={setNodeRef}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        backgroundColor: isOver ? '#e8f0fe' : undefined,
        borderRadius: isOver ? '0.25rem' : undefined,
        padding: isOver ? '0 0.25rem' : undefined
      }}
    >
      {children}
    </Breadcrumb.Item>
  )
}

// `ancestors` is outermost-first and excludes `folder` itself.
const FolderBreadcrumb = ({ folder, ancestors = [], onNavigateHome, onNavigateToFolder }) => {
  if (!folder) return null

  const isOwner = folder.is_owner !== false

  return (
    <div className="d-flex align-items-center gap-3">
      <Breadcrumb className="mb-0" listProps={{ className: 'flex-wrap mb-0' }}>
        <DroppableCrumb dropId="folder-root" onClick={onNavigateHome}>
          All Items
        </DroppableCrumb>
        {ancestors.map((ancestor) => (
          <DroppableCrumb
            key={ancestor.id}
            dropId={`folder-${ancestor.id}`}
            onClick={() => onNavigateToFolder(ancestor)}
          >
            {ancestor.name}
          </DroppableCrumb>
        ))}
        <Breadcrumb.Item active>{folder.name}</Breadcrumb.Item>
      </Breadcrumb>
      {!isOwner && folder.owner && (
        <small className="text-muted fst-italic">
          Shared by {folder.owner.first_name} {folder.owner.last_name}
        </small>
      )}
    </div>
  )
}

export default FolderBreadcrumb
